import { /* List, */ Map } from 'immutable';
const prefix = ['app', 'conference'];

export const codeFileSelector = (state) =>
  state.getIn([...prefix, 'codeFiles', 'data'], Map({})).toJS();

export const meetingSelector = (state) =>
  state.getIn([...prefix, 'meeting', 'instance']);
export const attendeeInfoSelector = (state) => {
  const meeting = state.getIn([...prefix, 'meeting', 'instance']);
  return meeting ? meeting.attendeeInfo || {} : {};
};
export const activeConferenceSelector = (state) =>
  state.getIn([...prefix, 'meeting', 'activeConference']);
export const conferenceMetaSelector = (state) =>
  state.getIn([...prefix, 'meeting', 'conferenceMeta']);
export const meetingPermissionsChecksSelector = (state) =>
  state.getIn([...prefix, 'meeting', 'permissionChecks']);
export const chatSelector = (state) =>
  state.getIn([...prefix, 'meeting', 'messages']);
export const conferencesSelector = (state) =>
  state.getIn([...prefix, 'conferences', 'current']).toJS();
export const conferencesPaginationSelector = (state) =>
  state.getIn([...prefix, 'conferences', 'current', 'pagination']).toJS();
export const pastConferencesSelector = (state) =>
  state.getIn([...prefix, 'conferences', 'past']).toJS();
export const pastConferencesPaginationSelector = (state) =>
  state.getIn([...prefix, 'conferences', 'past', 'pagination']).toJS();
export const helpSessionsSelector = (state) =>
  state.getIn([...prefix, 'helpSessions', 'current']).toJS();
export const helpSessionsPaginationSelector = (state) =>
  state.getIn([...prefix, 'helpSessions', 'current', 'pagination']).toJS();
export const pastHelpSessionsSelector = (state) =>
  state.getIn([...prefix, 'helpSessions', 'past']).toJS();
export const pastHelpSessionsPaginationSelector = (state) =>
  state.getIn([...prefix, 'helpSessions', 'past', 'pagination']).toJS();
export const endMeetingOptionsSelector = (state) =>
  state.getIn([...prefix, 'meeting', 'endMeetingOptions']);
